import { Link } from "react-router";
import { GO_PATH } from "@/features/go/router";

export const LoginFirstVisit = () => (
  <p className="text-sm text-gray-500 dark:text-gray-400">
    <span className="block font-semibold text-gray-900 dark:text-white">Première visite ?</span>
    Première connexion avec votre matricule ?
    {" "}
    <Link to={GO_PATH} className="font-semibold text-primary hover:underline" data-testid="login-first-visit-link">
      Cliquez ici
    </Link>
  </p>
);

LoginFirstVisit.displayName = "LoginFirstVisit";
